import React from 'react'
import { attachmentExtension, attachmentLabel } from 'utility/ticket-attachment'

// Only real http(s) links are opened (stored URLs come from clients; never javascript: / data:).
const safeUrl = url => (/^https?:\/\//i.test(String(url || '')) ? String(url) : '')

/**
 * Tile for a ticket attachment that is not a picture: extension badge + name; opens the file in a new tab.
 * `size` = tile width / height in px (the thumbnails around it use the same box). `style` overrides the outer box.
 */
export const TicketFileTile = ({ url, file, size = 64, onRemove, style }) => {
    const href = safeUrl(url)
    const label = attachmentLabel(file || url)
    const ext = (attachmentExtension(label) || 'file').toUpperCase().slice(0, 5)
    const content = (
        <>
            <span
                style={{
                    fontSize: size < 50 ? 9 : 11,
                    fontWeight: 700,
                    background: '#1b2587',
                    color: '#fff',
                    borderRadius: 4,
                    padding: '1px 4px',
                }}
            >
                {ext}
            </span>
            {size >= 50 && (
                <span
                    style={{
                        fontSize: 10,
                        marginTop: 4,
                        maxWidth: '100%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {label}
                </span>
            )}
        </>
    )
    const inner = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        padding: 4,
        boxSizing: 'border-box',
        color: '#1f2937',
        textDecoration: 'none',
    }
    return (
        <div
            title={label}
            style={{
                position: 'relative',
                width: size,
                height: size,
                border: '1px solid #d1d5db',
                borderRadius: 8,
                background: '#f8fafc',
                overflow: 'hidden',
                boxSizing: 'border-box',
                flex: '0 0 auto',
                ...style,
            }}
        >
            {href ? (
                <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={e => e.stopPropagation()}
                    style={{ ...inner, cursor: 'pointer' }}
                >
                    {content}
                </a>
            ) : (
                <div style={inner}>{content}</div>
            )}
            {onRemove && (
                <button
                    type="button"
                    title="Remove"
                    aria-label={`Remove ${label}`}
                    onClick={e => {
                        e.preventDefault()
                        e.stopPropagation()
                        onRemove()
                    }}
                    style={{
                        position: 'absolute',
                        top: 2,
                        right: 2,
                        width: 18,
                        height: 18,
                        padding: 0,
                        border: 'none',
                        borderRadius: '50%',
                        background: 'rgba(15,23,42,0.75)',
                        color: '#fff',
                        fontSize: 11,
                        lineHeight: '18px',
                        textAlign: 'center',
                        cursor: 'pointer',
                    }}
                >
                    ×
                </button>
            )}
        </div>
    )
}
